import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTechnicalReportById } from "../../actions/VehicleReplacementsActions";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { getBatchById } from "../../actions/BatchActions";
import numberToWords from 'number-to-words';
import { ThreeDots } from "react-loader-spinner";

function Invoice() {
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        dispatch(getBatchById(params.id))
    }, [params.id])

    const [vat, setVat] = useState();

    const batch = useSelector(state => state?.batch?.batch);
    const loading = useSelector(state => state?.loading?.addEditLoading);

    useEffect(() => {
        const vat = batch?.total_amount_count * 5 / 100;
        setVat(vat)
    }, [batch])

    const formattedHighestJobCardId = batch?.highestJobCard ? String(batch.highestJobCard).padStart(6, '0') : 0;
    const formattedSmallestJobCardId = batch?.smallestJobCard ? String(batch.smallestJobCard).padStart(6, '0') : 0;

    const amountToWords = (amount) => {
        const dollars = Math.floor(amount);
        const cents = Math.round((amount - dollars) * 100);

        const dollarsInWords = numberToWords.toWords(dollars);

        let centsInWords = '';
        if (cents > 0) {
            centsInWords = numberToWords.toWords(cents);
            centsInWords = `AND ${centsInWords.toUpperCase()} FILLS`;
        }

        return `${dollarsInWords.toUpperCase()} DHS ${centsInWords} ONLY/=`;
    };

    let total_amount = parseFloat(batch?.total_amount_count) + parseFloat(vat);
    total_amount = isFinite(total_amount) ? total_amount.toFixed(2) : 0;

    let amountInWords = amountToWords(total_amount);

    return (
        <React.Fragment>
            <body className="bg-white w-full h-screen overflow-visible">
                <div className="intro-y bg-white pt-10">
                    {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> :
                            <span>
                                <div className="bg-white container p-0">
                                    <div className="text-center text-sm-start">
                                        <div className="">
                                            <img src="/images/logo.png" width={'100%'} height={100} alt="" />
                                            <div className="text-center mt-5 text-decoration-underline fw-semibold fs-2xl">CONSOLIDATED TAX INVOICE</div>
                                        </div>

                                        <div className="fs-base container " style={{ display: 'flex', justifyContent: "space-between", paddingTop: '10px' }}>
                                            <div className="" style={{ display: 'flex', flexDirection: 'column', justifyContent: "start" }}>
                                                <div className="mt-1 text-start"> To : <span className="fw-medium">{batch?.insurance_company?.name}</span> </div>
                                                <div className="mt-1 text-start"> P.O Box : <span className="fw-medium">36679</span> </div>
                                                <div className="mt-1 text-start">Abu Dhabi, U.A.E</div>
                                                <div className="mt-1 text-start"> Phone : <span className="fw-medium">-</span> </div>
                                            </div>
                                            <div className="text-lg-end ms-lg-auto">
                                                <div className="my-4 mt-0" style={{ display: 'flex', justifyContent: "end" }}>
                                                    <div className="fs-base border border-gray-500 w-48 text-end pe-5">DATE</div>
                                                    <div className="fs-base border border-gray-500 text-center w-40 ps-3">{moment(batch?.created_at).format('YYYY-MM-DD')}</div>
                                                </div>
                                                <div className="my-4" style={{ display: 'flex', justifyContent: "end" }}>
                                                    <div className="fs-base border border-gray-500 w-48 text-end pe-5">BATCH INVOICE NO.</div>
                                                    <div className="fs-base border border-gray-500 text-center w-40 ps-3">{batch?.batch_id}</div>
                                                </div>
                                                <div className="my-4" style={{ display: 'flex', justifyContent: "end" }}>
                                                    <div className="fs-base border border-gray-500 w-48 text-end pe-5">TR No.</div>
                                                    <div className="fs-base border border-gray-500 text-center w-40 ps-3">100225206000003</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="py-5">
                                        <div className="overflow-x-auto">
                                            <table className="table table-bordered border-gray-500">
                                                <thead style={{ background: '#1c2076', color: '#fff' }}>
                                                    <tr style={{ background: '#1c2076', color: '#fff' }}>
                                                        <th style={{ padding: '5px' }} className="text-nowrap">S.No</th>
                                                        <th style={{ padding: '5px' }} className="text-nowrap">Tax Invoice Nos. (Range)</th>
                                                        <th style={{ padding: '5px' }} className="text-nowrap">No. of Invoice Count</th>
                                                        <th style={{ padding: '5px' }} className="text-nowrap">Date of Supply</th>
                                                        <th style={{ padding: '5px' }} className="text-nowrap">TOTAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ padding: '5px' }}>
                                                            <div className="fw-medium text-nowrap">1</div>
                                                        </td>
                                                        <td style={{ padding: '5px' }} className="fw-medium">FM: INV-TH-{formattedHighestJobCardId} TO: INV-TH-{formattedSmallestJobCardId}</td>
                                                        <td style={{ padding: '5px' }} className="fw-medium">{batch?.batch_detail_count}</td>
                                                        <td style={{ padding: '5px' }} className="fw-medium">{moment(batch?.created_at).format('YYYY-MM-DD')}</td>
                                                        <td style={{ padding: '5px' }} className="fw-medium">{parseFloat(batch?.total_amount_count).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '5px' }} className="fw-bold text-end" colSpan={4}>TOTAL W/O VAT</td>
                                                        <td style={{ padding: '5px' }} className="fw-bold">AED {parseFloat(batch?.total_amount_count).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '5px' }} className="fw-bold text-end" colSpan={4}>VAT 5%</td>
                                                        <td style={{ padding: '5px' }} className="fw-bold">AED {parseFloat(vat).toFixed(2)}</td>
                                                    </tr>
                                                </tbody>
                                                <tfoot style={{ background: '#1c2076', color: '#fff' }}>
                                                    <tr>
                                                        <td colSpan={3} className="text-center fw-medium p-2">
                                                            {amountInWords}
                                                        </td>
                                                        <td className="fw-medium p-2">
                                                            TOTAL INCL VAT
                                                        </td>
                                                        <td className="fw-medium p-2">
                                                            AED {parseFloat(parseFloat(batch?.total_amount_count) + parseFloat(vat)).toFixed(2)}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        <div className="w-full">
                                            <table className="table table-bordered border-gray-500 mt-5 w-half">
                                                <thead style={{ background: '#1c2076', color: '#fff' }}>
                                                    <tr>
                                                        <th colSpan={2} className="fs-xs text-italic text-uppercase py-1" style={{ background: '#1c2076', color: '#fff', }}>
                                                            Bank Details
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">Account name</td>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">Al Tharaa Auto Repairing Workshop L.L.C</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">Account No.</td>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">3707428855501</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">IBAN</td>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">AE370340003707428855501</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">Bank</td>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">Emirates Islamic Bank, Sharjah, U.A.E</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">Swift</td>
                                                        <td style={{ padding: '2px' }} className="fw-medium fs-xs px-5">MEBLAEAD</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row px-5 pb-10">
                                        <div className="col-sm-6 offset-6 text-center fs-sm mt-sm-0">
                                            <p style={{ fontStyle: "italic" }} className="mt-1" ><strong> For Al Tharaa Auto Repairing Workshop L.L.C</strong> <br />
                                                This is a system generated document and requires no signature</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-end justify-content-center" style={{ display: 'flex', alignItems: 'end', justifyContent: 'center', borderBottom: '15px solid #1c2076' }}>
                                    <div className="d-flex align-items-end justify-content-evenly" style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-evenly' }} >
                                        <div className="mt-2 px-1 fs-xs fw-medium"> Phone : <span className="">#1923195</span> </div>
                                        <div className="mt-2 px-1 fs-xs fw-medium border-start border-gray-500"> P.O. Box : <span className="">33878 Sharjah, U.A.E</span> </div>
                                        <div className="mt-2 px-1 fs-xs fw-medium border-start border-gray-500"> Mobile : <span className=""> 050- 8885608</span> </div>
                                        <div className="mt-2 px-1 fs-xs fw-medium border-start border-gray-500"> Email : <span className=""> casc2020@hotmail.com, h_abutt@yahoo.com</span> </div>
                                    </div>
                                </div>
                            </div>
                            </span>
                    }
            </div>
        </body>

        </React.Fragment >
    )
}

export default Invoice;